<template>
  <Card class="my-4 relative overflow-hidden border border-gray-200" :class="{ 'border border-yellow-300': selected }">
    <div class="flex">
      <div class="flex-1 text-sm text-white">
        <div class="items-center mt-3">
          <span class="mr-1">{{ code }}</span>
        </div>
        <div class="items-center mt-3">
          <span class="mr-1">{{ name }}</span>
        </div>
        <div class="items-center mt-3">
          <span class="mr-1">{{ sortorder }}</span>
        </div>
        <div class="items-center mt-3">
          <span class="mr-1">{{ price }}</span>
        </div>
        <div class="items-center mt-3">
          <span class="mr-1">{{ submenutag }}</span>
        </div>
        <div class="items-center mt-3">
          <span class="mr-1">{{ servicetag }}</span>
        </div>
        <div class="items-center mt-3 mb-3">
          <span class="mr-1">{{ description }}</span>
        </div>
      </div>
      <div class="flex-1">
        <img v-if="imgurlInternal" class="float-left" :src="imgurlInternal" alt="Product Image" />
        <div v-else class="no-image">تصویری موجود نیست</div>
      </div>
    </div>
    <div class="flex gap-2 justify-center items-center">
      <button id="Select" class="bg-blue-500 rounded-3xl w-32 text-sm" @click.prevent="$refs.file.click()">انتخاب فایل</button>
      <input type="file" ref="file" @change="onFileChanged" style="display:none">
      <button id="delete" class="bg-blue-500 rounded-3xl w-32 text-sm" @click="confirmRemoveImage">حذف تصویر</button>
    </div>
    <hr class="mt-1">
    <div class="flex justify-between">
      <router-link :to="`/cat/${catid}/edit/${id}`" class="bg-yellow-300 px-5 rounded-xl p-2 mt-2 text-xs">ویرایش</router-link>
      <button class="bg-red-400 rounded-xl p-2 mt-2 px-6 text-xs text-gray-100" @click="deleteMenuItem">حذف</button>
    </div>
  </Card>
</template>

<script>
import Card from "@/components/General/VCard";
import Swal from 'sweetalert2';
import { UploadImage, DeleteImage/*,DeleteMenuItem */} from "@/API/API.js";

export default {
  props: ['id', 'catid', 'code', 'name', 'sortorder', 'submenutag', 'price', 'description', 'baseurl', 'servicetag', 'imagepath', 'imgurl', 'selected'],
  name: 'MenuItemCard',
  emits: ['deleted'],
  components: { Card },
  data() {
    return {
      image: null,
      imgurlInternal: this.baseurl + '\\' + this.imgurl,
      updateSuccessful: false
    };
  },
  methods: {
    onFileChanged(event) {
      const file = event.target.files[0];
      this.image = file;
      this.onUpload();
    },
    onUpload() {
      const params = new FormData();
      params.append('Logo', this.image);
      this.$Progress.start();

      UploadImage('menuitem', String(this.id), params)
        .then(response => {
          this.imgurlInternal = this.baseurl + '\\' + response.data;
          this.updateSuccessful = true;
          this.$Progress.finish();
        })
        .catch(error => {
          this.$swal.fire(error.response.data.Message);
          //this.$swal.fire( error.response.data);
          this.$Progress.finish();
        });
    },
    removeImage() {
      const params = new FormData();
      params.append('Logo', this.image);
      this.$Progress.start();

      DeleteImage('menuitem', String(this.id), params)
        .then(response => {
          this.imgurlInternal = this.baseurl + '\\' + response.data;
          this.updateSuccessful = true;
          this.$Progress.finish();
        })
        .catch(error => {
          this.$swal.fire(error.response.data.Message);
          this.$Progress.finish();
        });
    },
    confirmRemoveImage() {
      Swal.fire({
        title: 'آیا برای حذف مطمئن هستید؟',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'بله، حذف شود!',
        cancelButtonText: 'لغو'
      }).then((result) => {
        if (result.isConfirmed) {
          this.removeImage();
        }
      });
    },
    deleteMenuItem() {
      //console.log(this.id)
      this.$emit('deleted', this.id);
      /*Swal.fire({
        title: 'آیا برای حذف مطمئن هستید؟',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'بله، حذف شود!',
        cancelButtonText: 'لغو'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$Progress.start();

          DeleteMenuItem(this.$store.slug,this.id)
            .then(() => {
              Swal.fire('حذف شد!', 'آیتم با موفقیت حذف شد.', 'success');
              this.$emit('deleted', this.id);
              //this.menuItems = this.menuItems.filter(item => item.id !== id);
              this.$Progress.finish();
            })
            .catch(error => {
              Swal.fire('خطا!', error.response.data.Message || 'خطایی رخ داد.', 'error');
              this.$Progress.finish();
            });
        }
      });*/
    }
  }
};
</script>

<style>
.no-image {
  width: 150px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ccc;
  background-color: #f0f0f0;
}
</style>